import { featureFlagResponse } from "../../../Components/Common/Leftbar";
import { get, patch } from "../../ApiService";
import { ApiUrl, SsoApiUrl } from "../../ApiUrl";

export const getCurrentUserData = async () => {
  try {
    const res = await get(SsoApiUrl.userManagement.userCurrent);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getCurrentUserProjects = async (ref: string) => {
  try {
    const res = await get(SsoApiUrl.userManagement.userProjects(ref));
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const updateUserData = async (ref: string, body: any) => {
  try {
    const res = await patch(SsoApiUrl.userManagement.user(ref), body);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getUserPreferences = async (region?: string | number) => {
  try {
    const res = await get(`${ApiUrl.profileModule.userPreferences}`, {
      region,
    });
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const updateUserPreferences = async (
  region: string | number,
  body: any
) => {
  try {
    const res = await patch(`${ApiUrl.profileModule.userPreferences}`, body, {
      region,
    });
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getFeatureFlags = async (): Promise<featureFlagResponse> => {
  try {
    const res = await get(`${SsoApiUrl.featureFlag}`);
    return res;
  } catch (error: any) {
    return error.response;
  }
};
